__turbopack_context__.v({
  "ctas": "page-module___8aEwW__ctas",
  "intro": "page-module___8aEwW__intro",
  "logo": "page-module___8aEwW__logo",
  "main": "page-module___8aEwW__main",
  "page": "page-module___8aEwW__page",
  "primary": "page-module___8aEwW__primary",
  "secondary": "page-module___8aEwW__secondary",
});
